import cardModule1 from "../Card/cardDefaultModuleProp";
import cardModule2 from "../Card/cardDefaultModuleProp2";
import cardModule3 from "../Card/cardDefaultModuleProp";
import cardModule4 from "../Card/cardDefaultModuleProp2";
import cardModule5 from "../Card/cardDefaultModuleProp";
import cardModule6 from "../Card/cardDefaultModuleProp2";
import cardModule7 from "../Card/cardDefaultModuleProp";
import cardModule8 from "../Card/cardDefaultModuleProp2";

const cardsModule = {
  // other module props
  id: "66165fd1-dbee-312e-abf8-ae7dc257ad87",
  config: {
    general: {
      paddings: {
        top: true,
        bottom: true,
      },
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
        // url: 'https://css-tricks-post-videos.s3.us-east-1.amazonaws.com/708209935.mp4',
        mediaType: "image",
      },
      moduleBackgroundColor: {
        label: "Midnight",
        value: "#3c4b5f",
      },
      cardBackgroundColor: {
        label: "thistle",
        value: "thistle",
      },
      template: {
        label: "Portrait Small",
        component: "CardPortraitSmall",
      },
      showBackgroundMedia: false,
      showCardsMedia: true,
      showHeader: true,
      showText: true,
      showCtaButton: true,
      corners: {
        label: "Round",
        value: "round",
      },
      imageProportions: {
        label: "Default",
        value: "default", //"fourToThree", "sixteenToNine", "oneToOne"
      },
    },
  },
  modules: [
    cardModule1,
    cardModule2,
    cardModule3,
    cardModule4,
    cardModule5,
    cardModule6,
    cardModule7,
    cardModule8,
  ],
};

export default cardsModule;
